const element = (
  <div className="text-center text-gray-600">
    <p> This text is actually saved as a variable </p>
  </div>
)

function ReactElement() {
  return element
}

export default ReactElement